module.exports = __webpack_public_path__ + "img/SES_120420001.ba742d43.jpg";